import {
  gamificationEventsSeenBodySchema,
  gamificationMeResponseSchema,
  gamificationPinBodySchema,
  gamificationPinResponseSchema,
  gamificationPublicResponseSchema,
  publicPinnedTrophyNullableSchema,
  publicPinnedTrophySchema,
  type CareerTierId,
  type GamificationEventType,
  type GamificationEventsSeenBody,
  type GamificationMeResponse,
  type GamificationPinBody,
  type GamificationPinResponse,
  type GamificationPrivatePinned,
  type GamificationPublicResponse,
  type PublicPinnedTrophy,
  type TrophyId,
} from '@crowdfpl/domain/gamification';
import { z } from 'zod';

export {
  gamificationEventsSeenBodySchema,
  gamificationMeResponseSchema,
  gamificationPinBodySchema,
  gamificationPinResponseSchema,
  gamificationPublicResponseSchema,
  publicPinnedTrophyNullableSchema,
  publicPinnedTrophySchema,
  type CareerTierId,
  type GamificationEventType,
  type GamificationEventsSeenBody,
  type GamificationMeResponse,
  type GamificationPinBody,
  type GamificationPinResponse,
  type GamificationPrivatePinned,
  type GamificationPublicResponse,
  type PublicPinnedTrophy,
  type TrophyId,
};

function envelopeSchema<T extends z.ZodTypeAny>(
  dataSchema: T,
): z.ZodObject<{ success: z.ZodLiteral<true>; data: T }> {
  return z.object({
    success: z.literal(true),
    data: dataSchema,
  });
}

export const gamificationMeResponseEnvelopeSchema = envelopeSchema(gamificationMeResponseSchema);
export const gamificationPublicResponseEnvelopeSchema = envelopeSchema(gamificationPublicResponseSchema);
export const gamificationPinResponseEnvelopeSchema = envelopeSchema(gamificationPinResponseSchema);
export const gamificationEventsSeenResponseSchema = z.null();

export type GamificationMeState = GamificationMeResponse;
export type GamificationPublicState = GamificationPublicResponse;
export type SetGamificationPinRequest = GamificationPinBody;
export type SetGamificationPinResponse = GamificationPinResponse;
export type ClearGamificationPinResponse = GamificationPinResponse;
export type MarkGamificationEventsSeenRequest = GamificationEventsSeenBody;
export type MarkGamificationEventsSeenResponse = z.infer<typeof gamificationEventsSeenResponseSchema>;
